'use client';

import * as React from 'react';

import { ResourceBadge } from '@/components/ui/resource-badge';
import { useStoreNavigate } from '@/hooks/use-app-navigate';

interface OfferResourceBadgeProps {
  offerId: string;
  variant?: 'default' | 'secondary' | 'destructive' | 'outline';
  className?: string;
}

/**
 * PaymentResourceBadge component for displaying payment information
 * Inherits from generic ResourceBadge
 */
export function OfferResourceBadge({
  offerId,
  variant = 'secondary',
  className,
}: OfferResourceBadgeProps) {
  const { storeRoutes } = useStoreNavigate();
  // Format display value based on available data
  const displayValue = React.useMemo(() => {
    return `${offerId.substring(0, 8)}...`;
  }, [offerId]);

  return (
    <ResourceBadge
      name="variant"
      value={displayValue}
      appLink={storeRoutes.OFFER_EDIT(offerId)}
      variant={variant}
      className={className}
    />
  );
}
